import React from "react";
import "./Facilitymanagement.css";
import Footer from "../Footer";
import fimage from "../../assets/Fimage.jpeg"; 

export default function Facilitymanagement() {
  return (
    <>
    <div className="facility-container">
      <h1 className="facility-title">إدارة المرافق</h1>
      <div className="image-container">
        <img src={fimage} alt="fImage" className="f-image" />
      </div>
      <p className="facility-paragraph">
        إدارة المرافق هي مجال متعدد التخصصات يهتم بتنسيق الأنشطة بين المباني والأشخاص والبنية التحتية والطاقة والمياه وخدمات الصرف الصحي لضمان التشغيل المتناغم وإطالة عمر الأصول والخدمات المعنية.
      </p>
      <p className="facility-paragraph">
        تشمل الخدمات الرئيسية في إدارة المرافق صيانة المباني التجارية والعامة مثل الفنادق والمنتجعات والمدارس والمجمعات المكتبية والساحات الرياضية ومراكز المؤتمرات والمستشفيات والمطارات. قد تشمل المهام التكييف، الطاقة الكهربائية، السباكة، أنظمة الإضاءة، التنظيف العام، الديكور، صيانة المساحات الخارجية، وخدمات الأمن والسلامة. يمكن أداء جميع هذه المهام بمساعدة برامج كمبيوتر.
      </p>
      <p className="facility-paragraph">
        تُعتبر هذه المهام أيضًا خدمات داعمة أو غير أساسية لأنها ليست العمل الرئيسي للمنظمة المالكة. يتمثل الدور الوظيفي لإدارة المرافق في تنسيق والإشراف على تشغيل وصيانة هذه الأصول بطريقة آمنة وفعالة بيئيًا وبتكلفة مناسبة، بهدف الحفاظ على قيمة الأصول على المدى الطويل.
      </p>
      <p className="facility-paragraph">
        عندما تتضمن عمليات المرافق المستخدمين أو العملاء مباشرة، تصبح جودة الخدمة المقدمة لهؤلاء الأشخاص ذات أهمية قصوى، لذا يُستخدم مصطلح "رضا المستخدم النهائي" كمقياس أداء رئيسي.
      </p>
      <p className="facility-paragraph">
        إدارة المرافق تختلف عن إدارة الممتلكات، رغم التشابه في المصطلحات. تركز إدارة الممتلكات على أنشطة مثل التأجير والتسويق، بينما يركز مدير المرافق على المستأجرين الحاليين واحتياجاتهم. تأخذ إدارة المرافق بعين الاعتبار احتياجات البشر من مستخدمي المباني.
      </p>
      <p className="facility-paragraph">
        أحد المفاهيم المهمة هو الاستعانة بمصادر خارجية، حيث يتم الاتفاق مع منظمات خارجية لتوفير الخدمات بدلاً من تنفيذها داخليًا، وذلك لأسباب تتعلق بنقص الموارد أو الخبرة أو لتقليل التكاليف.
      </p>
      <p className="facility-paragraph">
        تحدث إدارة المرافق خلال مرحلة التشغيل لعمر المبنى، مما يجعلها عملية مستمرة لدعم الأعمال الأساسية للمالك. ويُفضل أن تكون قرارات التصميم والإنشاء موجهة لدعم احتياجات التشغيل لضمان أفضل دعم ممكن.
      </p>
      <h2 className="facility-subtitle">الدور</h2>
      <p className="facility-paragraph">
        يعمل مديرو المرافق على مستويين: التخطيط الاستراتيجي والتشغيلي. يشمل ذلك التخطيط للمساحات والخدمات، وضمان التشغيل الأمثل لكافة الجوانب.
      </p>
      <ul className="facility-list">
        <li>الصحة البيئية والسلامة</li>
        <li>نظافة المباني</li>
        <li>التخلص من النفايات</li>
        <li>الامتثال لمعايير السلامة (مثل OSHA)</li>
        <li>أنظمة ميكانيكية: التكييف والتدفئة والتهوية والتبريد</li>
        <li>جودة الهواء الداخلي والتحكم في درجة الحرارة</li>
        <li>الصيانة الوقائية والتنبؤية وصيانة المصاعد</li>
        <li>أنظمة الطاقة: طاقة منتظمة، مولدات احتياطية، UPS</li>
        <li>أنظمة المباني: الأتمتة، المراقبة، الأمن، الأقفال</li>
        <li>أنظمة السلامة: الري، الكشف عن الحرائق، طفايات الحريق (FM-200, FE-25, Halon)</li>
        <li>خطط الإخلاء، الإشارات</li>
        <li>إدارة المكان: تخطيط المساحات، الأثاث والتركيب</li>
      </ul>

      <h2 className="facility-subtitle">التعريفات</h2>
      <p className="facility-paragraph">
        وفقًا للمؤسسة الدولية لإدارة المرافق (IFMA): "مهنة تشمل عدة تخصصات، تضمن الأداء الوظيفي للبيئة المبنية من خلال تكامل الأشخاص والمكان والعمليات والتكنولوجيا."
      </p>
      <p className="facility-paragraph">
        التعريف الأوروبي: "إدارة المرافق هي دمج العمليات الجارية داخل المنظمة للحفاظ على الخدمات المتفق عليها وتطويرها لدعم وتحسين فعالية الأنشطة الأساسية."
      </p>
      <p className="facility-paragraph">
        في أستراليا، يُستخدم مصطلح "خدمات الأعمال" أحيانًا بدلاً من إدارة المرافق.
      </p>

      <h2 className="facility-subtitle">مصطلحات مهمة</h2>
      <ul className="facility-list">
        <li>الموقع: مبنى أو عدة مبانٍ في قطعة أرض واحدة</li>
        <li>الحرم الجامعي: مواقع متعددة في نفس المدينة لكيان قانوني واحد</li>
        <li>أنظمة إدارة المرافق بمساعدة الكمبيوتر (CAFM)</li>
        <li>أتمتة المباني: ربط الأجهزة في شبكة ذكية للتحكم التلقائي</li>
        <li>الفرق بين الإدارة التقنية والإدارية</li>
      </ul>

      <h2 className="facility-subtitle">مكونات أنظمة الإدارة الأفضل</h2>
      <ul className="facility-list">
        <li>شهادة التأمين</li>
        <li>تتبع الحوادث</li>
        <li>إدارة المشاريع</li>
        <li>الصيانة الوقائية</li>
        <li>وسائل الاتصال الآلي</li>
        <li>إدارة الزوار</li>
        <li>الحماية</li>
        <li>السلامة من الحرائق والحياة</li>
        <li>المحاسبة</li>
      </ul>
    </div>
    <Footer/>
    </>
  );
}
